<template>
  <div class="quiz-result">
    <div class="content columns">
      <div class="title-col column col-12">
        <div class="title title-col__title desktop-hidden">
          <span class="title-col__text">
            Kreatorka rozwiązań
          </span>
        </div>
      </div>
      <div class="images-col column col-4 col-sm-12">
        <div class="thumbnail">
          <img :src="require('@/assets/images/pic-s3-kreatorka-rozwiazan.png')"
               alt="Segment" class=" img-responsive thumbnail-image" />
        </div>
      </div>
      <div class="description column">
        <div class="title title-col__title mobile-hidden">
          <span class="title-col__text">
            Kreatorka rozwiązań
          </span>
        </div>
        <div class="description__content">
          <p class="quote">
            "Dla każdego problemu znajdę sposób"
          </p>
          <p>
            W Twoim świecie wszystko ma swoje miejsce – również emocje, decyzje i działania.
            Lubisz wiedzieć, co, jak i dlaczego działa.
            Nie porywasz się na ślepo, nie działasz impulsywnie –
            za to doskonale planujesz, analizujesz i krok po kroku realizujesz cele.
            Twoją domeną nie jest chaos – jest nią skuteczność oparta na wiedzy i strukturze.
          </p>
          <p>
            Nie szukasz błysków fajerwerków, ale prawdziwego sensu i rozwoju.
            Potrzebujesz mieć wpływ, budować coś, co zostanie, ulepszać świat –
            nawet jeśli ma to być tylko Twoja własna codzienność.
            Uważnie słuchasz, cenisz feedback i nie boisz się konstruktywnej krytyki –
            wręcz ją zapraszasz, bo wszystko można przecież zrobić lepiej.
          </p>
          <p>
            W relacjach jesteś lojalna, wyważona, konkretna.
            Nie dominujesz rozmów, ale kiedy się odzywasz – każdy wie, że warto słuchać.
            Cenisz ludzi, którzy działają mądrze i mają coś do powiedzenia.
            I choć czasem możesz wydawać się zdystansowana –
            wiesz, kiedy być wsparciem, a kiedy liderką.
          </p>
          <p>
            Twoja supermoc? Przekuwasz skomplikowane problemy w proste rozwiązania.
            Bez dramatów, bez nadmiaru słów – po prostu skutecznie.
            Świat może być nieprzewidywalny, ale Ty jesteś jego cichą inżynierką.
            I właśnie dlatego tak bardzo Cię potrzebuje.
          </p>
          <p>
            <strong>Twoje wartości:</strong> rozwój, efektywność, eksperckość<br/>
            <strong>Styl życia:</strong> uporządkowany, strategiczny, zorientowany na cel<br/>
            <strong>W relacjach:</strong> rzeczowa, uważna, wspierająca tam, gdzie trzeba<br/>
            <strong>Supermoc:</strong> przekuwasz skomplikowane problemy w proste rozwiązania
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KreatorkaRozwiazan',
};
</script>

<style scoped>
.title-col__text {
  color: var(--color-kreatorka) !important;
}
.thumbnail-image {
  border-radius: 900px;
}
.quiz-result .percentage__value {
  color: var(--color-kreatorka);
}
.quiz-result .quote {
  font-style: italic;
  font-weight: 600;
  font-size: 22px;
}
</style>
